import { memo } from 'react';
import type { TunableParam } from '../../../types/TunableParam';
import { DynamicControl } from './DynamicControl';

interface QuickTuneGroupProps {
    nodeId: string;
    nodeTitle: string;
    nodePath: string;
    params: TunableParam[];
    pendingChanges: Map<string, any>;
    onLocalChange: (nodeId: string, paramKey: string, newValue: number | boolean | string) => void;
}

export const QuickTuneGroup = memo(function QuickTuneGroup({
    nodeTitle,
    nodePath,
    params,
    pendingChanges,
    onLocalChange
}: QuickTuneGroupProps) {
    return (
        <div
            style={{
                marginBottom: '1.5rem',
                padding: '0.75rem',
                background: 'var(--surface-glass)',
                border: '1px solid var(--surface-glass-border)',
                borderRadius: 'var(--radius-md)',
            }}
        >
            <div
                style={{
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    marginBottom: '0.5rem',
                    color: 'var(--text-primary)',
                }}
            >
                {nodeTitle}
            </div>
            <div
                style={{
                    fontSize: '0.7rem',
                    color: 'var(--text-muted)',
                    marginBottom: '0.75rem',
                }}
            >
                {nodePath}
            </div>

            {params.map((param) => {
                const changeKey = `${param.nodeId}:${param.paramKey}`;
                const pendingValue = pendingChanges.get(changeKey)?.newValue;
                const currentValue = pendingValue !== undefined ? pendingValue : param.paramValue;

                return (
                    <div key={param.paramKey} style={{ marginBottom: '1rem' }}>
                        <DynamicControl
                            param={param}
                            currentValue={currentValue}
                            onChange={onLocalChange}
                        />
                    </div>
                );
            })}
        </div>
    );
});

